<template>
  <div :class="[ isTeacher ? 'teacher-view' : 'student-view' ]">
    <headerComponent/>

    <!-- Game Template -->
    <div class="size margin" :class="{ 'size--ec': isEC }">
      <div class="animation-bottom animation-delay-01">
        <!-- <inicialClass/> -->
        <subTopicTemplate>
          <template slot-scope="{ topic, subTopic }">
            <!-- SubTopics -->
            <!-- <selectQuestion ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <!-- <listenSelectImage ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <!-- <watchSelectWord ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <!-- <completeDialog ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <!-- <videoSelect ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <!-- <videoSelectQuestion ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <!-- <watchSelectTimer ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <!-- <listenSelectImageQuestion ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <!-- <imageSpeech ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <!-- <dragNDrop ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <!-- <imageSelectAudio ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <!-- <answerSelect ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <!-- end SubTopics -->

            <!-- <answerSelectQuestion ref="game" :topic="topic" :subTopic="subTopic" /> esse nao tem -->

            <!-- Games -->
            <!-- <speakWordGame ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <!-- <memoryGame ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <!-- <interactiveVideoGame ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <!-- <trueOrFalseGame ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <!-- <imagePairingGame ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <!-- <multipleChoiceGame ref="game" :topic="topic" :subTopic="subTopic" /> -->

            <!-- New -->
            <!-- <writeWord ref="game" :topic="topic" :subTopic="subTopic" /> -->
            <completePhrase ref="game" :topic="topic" :subTopic="subTopic" />
            <!-- <englishCentral ref="game" :topic="topic" :subTopic="subTopic" /> -->

            <!-- Modal Finish SubTopic -->
            <!-- <modal ref="modal" v-if="true" :show="true" :closebtn="false" bgcolor="rgba(243, 243, 243, .95)"> -->
              <!-- <modalSubTopic :questions="[]" :topic="{score:100, percent:20, title: 'Another Brick'}" :subTopic="{points:70}"/> -->
              <!-- <modalUnit :questions="[]" :unit="{score:40, number: 3}"/> -->
            <!-- </modal> -->

          </template>


        </subTopicTemplate>
      </div>
    </div>
    <!-- end Game Template -->

    <!-- Main Template -->
    <!-- <div class="size margin container align-items-stretch wrap justify-content-center">
      <div class="col-12 col-xl-9 col-lg-9 col-md-8 col-sm-12 container column">
        <achievementsComponent/> -->
        <!-- <perfilPage/> -->
        <!-- <books/>
      </div>
      <sidebarComponent/>
    </div> -->
    <!-- end Main Template -->
    <!-- <footerComponent/> -->
    <!-- <div class="modal-call modal-call__animation--open" ref="modal" v-if="true">
      <div class="modal-call__talking">
        <span class="modal-call__talking__classroomkey" v-if="isTeacher">QWEsdw22sd-2</span>
        <div class="container wrap modal-call__talking__box">
          <div class="modal-call__talking__streams">
            <div class="modal-call__talking__streams__mine">
              <video ref="teacher_video" class="modal-call__talking__streams__mine__teacher" autoplay muted/>
            </div>
            <div class="modal-call__talking__streams__others">
              <student-video-chat
                v-for="(student, index) in students.sort(s => s.hand_raised ? -1 : 0)"
                :key="student._id"
                :student="student"
                :ref="`student_video_${student._id}`"
                :canMute="isTeacher"
                :setMuted="setMuted"
              />
            </div>
          </div>
          <chat-box
            :chat="chat.filter(c => isTeacher ? true : (!c.notification ? true : !c.message.match('have a question')))"
            person="1"
            :sendMessage="sendMessage"
            :hasStream="!isTeacher"
            :padding="!isTeacher"
            :muted="true"
            :startRecording="() => true"
          />
        </div>
        <div class="modal-call__talking__hand" v-if="!isTeacher">
          <div class="modal-call__talking__hand__icon" @click="">
            <font-awesome-icon icon="hand-paper"/>
          </div>
        </div>
        <div class="modal-call__talking__hangup">
          <div class="modal-call__talking__hangup__icon" @click="">
            <font-awesome-icon icon="phone-slash"/>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <Loader :loading="true"/> -->
    <modalPdf/>
  </div>
</template>

<style lang="scss">
@import './src/assets/css/components/_unitChallenge';
.life-box {
  width: 75px;
  .life-item {
    margin-left: 5px;
    &:first-child {
      margin-left: 10px;
    }
  }
}

.test-box {
  height: 400px;
}

// Calling modal
.teacher-view {
  .modal-call {
    overflow: hidden;
    display: flex;
    justify-content: center;
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 999;
    top: 0;
    left: 0;
    background-color: rgba(25, 25, 25, 0.95);
    color: #fff;
    &.modal-call__animation--open {
      animation: open .8s ease-in;
    }
    &.modal-call__animation--close {
      animation: close .5s ease-out;
    }
    &__talking {
      &__box {
        height: calc(100% - 77px);
        max-height: calc(100% - 77px);
      }
      position: relative;
      width: 100%;
      height: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
      align-self: center;
      overflow: hidden;
      z-index: 100;
      &__classroomkey {
        color: $color-red;
        font-size: 32px;
        margin: 20px auto;
      }
      &__streams {
        min-width: 350px;
        padding: 0 10px 10px 10px;
        flex: 1;
        display: flex;
        flex-direction: column;
        max-height: 100%;
        &__mine {
          display: flex;
          justify-content: center;
          height: auto;
          flex: 1;
          max-height: 60%;
          &__teacher {
            width: 100%;
            height: auto;
          }
        }
        &__others {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          max-height: 40%;
          overflow-y: auto;
        }
      }
      &__hangup {
        cursor: pointer;
        position: absolute;
        top: 7px;
        right: 20px;
        background-color: #C20030;
        color: #fff;
        padding: 15px 13px;
        border-radius: 150px;
        svg {
          font-size: 30px;
        }
      }
    }
  }

  @media screen and (max-width: 800px) {
    .modal-call__talking {
      &__box {
        height: calc(100% - 35vh - 77px);
        max-height: calc(100% - 35vh - 77px);
      }
      &__streams__mine {
        height: calc(100% - 175px);
        max-height: calc(100% - 175px);
      }
      &__streams__others {
        height: 175px;
        flex-wrap: nowrap;
      }
    }
  }
}

.student-view {
  .modal-call {
    overflow: hidden;
    display: flex;
    justify-content: center;
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 999;
    top: 0;
    left: 0;
    background-color: rgba(25, 25, 25, 0.95);
    color: #fff;
    &.modal-call__animation--open {
      animation: open .8s ease-in;
    }
    &.modal-call__animation--close {
      animation: close .5s ease-out;
    }
    &__talking {
      &__box {
        height: 100%;
        max-height: 100%;
      }
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-self: center;
      overflow: hidden;
      z-index: 100;
      &__classroomkey {
        color: $color-red;
        font-size: 32px;
        margin: 20px auto;
      }
      &__streams {
        min-width: 350px;
        padding: 10px;
        flex: 1;
        display: flex;
        flex-direction: column;
        max-height: 100%;
        &__mine {
          display: flex;
          justify-content: center;
          height: auto;
          flex: 1;
          max-height: 60%;
          &__teacher {
            width: 100%;
            height: auto;
          }
        }
        &__others {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          max-height: 40%;
          overflow-y: auto;
          &__box {
            min-width: 200px;
            max-width: calc((100% / 6) - (6 * 10px));
            padding: 5px;
            cursor: pointer;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
            &__student {
              width: auto;
              height: auto;
              max-width: calc(100% - 10px);
              max-height: calc(100% - 10px);
            }
            &__student--svg {
              width: 63% !important;
              height: auto;
            }
          }
        }
      }
      &__hangup {
        cursor: pointer;
        position: absolute;
        top: 7px;
        right: 20px;
        background-color: #C20030;
        color: #fff;
        padding: 15px 13px;
        border-radius: 150px;
        svg {
          font-size: 30px;
        }
      }
      &__hand {
        cursor: pointer;
        position: absolute;
        top: 7px;
        right: 90px;
        background-color: $color-blue;
        color: #fff;
        padding: 15px 18px;
        border-radius: 150px;
        svg {
          font-size: 30px;
        }

        &.disabled {
          cursor: not-allowed;
        }
      }
    }
  }

  @media screen and (max-width: 800px) {
    .modal-call__talking {
      &__box {
        padding-top: 77px;
        padding-bottom: 10px;
        height: calc(100% - 35vh);
        max-height: calc(100% - 35vh);
      }
      &__streams__mine {
        height: calc(100% - 175px);
        max-height: calc(100% - 175px);
      }
      &__streams__others {
        height: 175px;
        flex-wrap: nowrap;
      }
    }
  }
}

@keyframes open {
  0% {
    clip-path: circle(0% at 50% 50%);
    opacity: 0;
  }
  100% {
    clip-path: circle(100% at 50% 50%);
    opacity: 1;
  }
}

@keyframes close {
  0% {
    clip-path: circle(100% at 50% 50%);
    opacity: 1;
  }
  100% {
    clip-path: circle(0% at 50% 50%);
    opacity: 0;
  }
}

@keyframes calling {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes callingEntry {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>

<script type="text/javascript">
import { mapGetters } from 'vuex'
import gameBus from '@/components/game/gameBus'

import headerComponent from '@/components/header'
import footerComponent from '@/components/footer'
import achievementsComponent from '@/components/achievements'
import sidebarComponent from '@/components/sidebar'

import subTopicTemplate from '@/components/template/subTopic'

// Initial Class
import inicialClass from '@/pages/video'

// SubTopics
import answerSelectQuestion from '@/components/game/answerSelectQuestion'
import completeDialog from '@/components/game/completeDialogGame'
import completePhrase from '@/components/game/completePhrase'
import dragNDrop from '@/components/game/dragNDrop'
import imageSelectAudio from '@/components/game/imageSelectAudio'
import imageSpeech from '@/components/game/imageSpeech'
import listenSelectImage from '@/components/game/listenSelectImage'
import listenSelectImageQuestion from '@/components/game/listenSelectImageQuestion'
import selectQuestion from '@/components/game/selectQuestion'
import videoSelect from '@/components/game/videoSelect'
import videoSelectQuestion from '@/components/game/videoSelectQuestion'
import watchSelectTimer from '@/components/game/watchSelectTimer'
import watchSelectWord from '@/components/game/watchSelectWord'
import writeWord from '@/components/game/writeWord'
import englishCentral from '@/components/game/englishCentral'
import answerSelect from '@/components/game/answerSelect'

// Games
import imagePairingGame from '@/components/game/imagePairingGame'
import interactiveVideoGame from '@/components/game/interactiveVideoGame'
import speakWordGame from '@/components/game/speakWordGame'
import trueOrFalseGame from '@/components/game/trueOrFalseGame'
import memoryGame from '@/components/game/memoryGame'
import multipleChoiceGame from '@/components/game/multipleChoiceGame'

// Pages
import words from '@/pages/words'

// Perfil
import perfilPage from '@/pages/perfil'

// Books
import books from '@/pages/library/books'

// Loader
import Loader from '@/components/loader/mainLoader'

// Modal
import modalPdf from '@/components/modal/modalPdf'
import modalSubTopic from "@/components/modal/modalSubTopic";
import modalUnit from "@/components/modal/modalUnit";
import modal from "@/components/modal";

// Online class
import ChatBox from '@/components/ChatBox'
import StudentVideoChat from '@/components/StudentVideoChat'

export default {
  data () {
    return {
      students: [
        {
          _id: 1,
          name: 'Test 1',
          active: true,
          has_media: true,
          muted: true,
          hand_raised: true
        },
        {
          _id: 2,
          name: 'Test 2',
          active: true,
          has_media: false,
          muted: true
        },
        {
          _id: 3,
          name: 'Test 3',
          active: false,
          has_media: true,
          muted: true
        },
        {
          _id: 4,
          name: 'Test 4',
          active: true,
          has_media: true,
          muted: true
        },
        {
          _id: 5,
          name: 'Test 5',
          active: true,
          has_media: true,
          muted: true
        },
        {
          _id: 6,
          name: 'Test 6',
          active: true,
          has_media: false,
          muted: true
        },
        {
          _id: 7,
          name: 'Test 7',
          active: false,
          has_media: true,
          muted: true
        },
        {
          _id: 8,
          name: 'Test 8',
          active: true,
          has_media: true,
          muted: true
        },
        {
          _id: 9,
          name: 'Test 9',
          active: true,
          has_media: false,
          muted: true
        },
        {
          _id: 10,
          name: 'Test 10',
          active: true,
          has_media: true,
          muted: true,
          hand_raised: true
        },
        {
          _id: 11,
          name: 'Test 11',
          active: true,
          has_media: false,
          muted: true
        },
        {
          _id: 12,
          name: 'Test 12',
          active: false,
          has_media: true,
          muted: true
        }
      ],
      chat: [
        {
          message: `Test 1 joined room`,
          created_at: -1,
          notification: true,
          notification_type: 'join'
        },
        {
          name: 'Test 1',
          _id: 1,
          message: 'Oi from 1',
          is_media: true,
          media_url: 'https://dl.espressif.com/dl/audio/ff-16b-2c-44100hz.mp3',
          created_at: 0
        },
        {
          name: 'Test 2',
          _id: 2,
          message: 'Oi from 2',
          is_media: true,
          media_url: 'https://dl.espressif.com/dl/audio/ff-16b-2c-44100hz.mp3',
          created_at: 1
        },
        {
          name: 'Test 3',
          _id: 3,
          message: 'Oi from 3',
          is_media: false,
          media_url: null,
          created_at: 2
        },
        {
          name: 'Test 4',
          _id: 4,
          message: 'Oi from 4',
          is_media: false,
          media_url: null,
          created_at: 3
        },
        {
          name: 'Test 5',
          _id: 5,
          message: 'Oi from 5',
          is_media: false,
          media_url: null,
          created_at: 4
        },
        {
          name: 'Test 6',
          _id: 6,
          message: 'Oi from 6',
          is_media: false,
          media_url: null,
          created_at: 5
        },
        {
          name: 'Test 7',
          _id: 7,
          message: 'Oi from 7',
          is_media: false,
          media_url: null,
          created_at: 6
        },
        {
          name: 'Test 8',
          _id: 8,
          message: 'Oi from 8',
          is_media: false,
          media_url: null,
          created_at: 7
        },
        {
          name: 'Test 9',
          _id: 9,
          message: 'Oi from 9',
          is_media: false,
          media_url: null,
          created_at: 8
        },
        {
          name: 'Test 10',
          _id: 10,
          message: 'Oi from 10',
          is_media: false,
          media_url: null,
          created_at: 9
        },
        {
          name: 'Test 11',
          _id: 11,
          message: 'Oi from 11',
          is_media: false,
          media_url: null,
          created_at: 10
        },
        {
          name: 'Test 12',
          _id: 12,
          message: 'Oi from 12',
          is_media: false,
          media_url: null,
          created_at: 11
        },
        {
          message: `Test 1 have a question`,
          created_at: 11.5,
          notification: true,
          notification_type: 'attention'
        },
        {
          name: 'Test 1',
          _id: 1,
          message: 'Tchau from 1',
          is_media: false,
          media_url: null,
          created_at: 12
        },
        {
          message: `Test 2 have a question`,
          created_at: 12.5,
          notification: true,
          notification_type: 'attention'
        },
        {
          name: 'Test 1',
          _id: 1,
          message: 'Adios',
          is_media: false,
          media_url: null,
          created_at: 13
        },
        {
          message: `Test 1 left`,
          created_at: 13.5,
          notification: true,
          notification_type: 'leave'
        },
        {
          name: 'Test 2',
          _id: 2,
          message: 'Tchau from 2',
          is_media: false,
          media_url: null,
          created_at: 14
        },
        {
          name: 'Test 3',
          _id: 3,
          message: 'Tchau from 3',
          is_media: true,
          media_url: 'https://dl.espressif.com/dl/audio/ff-16b-2c-44100hz.mp3',
          created_at: 15
        },
        {
          name: 'Test 4',
          _id: 4,
          message: 'Tchau from 4',
          is_media: false,
          media_url: null,
          created_at: 16
        },
        {
          name: 'Test 5',
          _id: 5,
          message: 'Tchau from 5',
          is_media: true,
          media_url: 'https://dl.espressif.com/dl/audio/ff-16b-2c-44100hz.mp3',
          created_at: 17
        },
        {
          name: 'Test 6',
          _id: 6,
          message: 'Tchau from 6',
          is_media: false,
          media_url: null,
          created_at: 18
        },
        {
          name: 'Test 7',
          _id: 7,
          message: 'Tchau from 7',
          is_media: false,
          media_url: null,
          created_at: 19
        },
        {
          name: 'Test 8',
          _id: 8,
          message: 'Tchau from 8',
          is_media: false,
          media_url: null,
          created_at: 20
        },
        {
          name: 'Test 9',
          _id: 9,
          message: 'Tchau from 9',
          is_media: false,
          media_url: null,
          created_at: 21
        },
        {
          name: 'Test 10',
          _id: 10,
          message: 'Tchau from 10',
          is_media: false,
          media_url: null,
          created_at: 22
        },
        {
          name: 'Test 11',
          _id: 11,
          message: 'Tchau from 11',
          is_media: false,
          media_url: null,
          created_at: 23
        },
        {
          name: 'Test 11',
          _id: 11,
          message: 'Tchau from 11 again',
          is_media: false,
          media_url: null,
          created_at: 24
        },
        {
          message: `Test 11 left`,
          created_at: 24.5,
          notification: true,
          notification_type: 'leave'
        },
        {
          name: 'Test 12',
          _id: 12,
          message: 'Tchau from 12',
          is_media: false,
          media_url: null,
          created_at: 25
        }
      ],
      isTeacher: false
    }
  },
  computed: {
    isEC () {
      return this.$store.getters['isEC']
    }
  },
  components: {
    headerComponent,
    footerComponent,
    achievementsComponent,
    sidebarComponent,
    subTopicTemplate,
    // SubTopics
    answerSelectQuestion,
    completeDialog,
    completePhrase,
    dragNDrop,
    imageSelectAudio,
    imageSpeech,
    listenSelectImage,
    listenSelectImageQuestion,
    selectQuestion,
    videoSelect,
    videoSelectQuestion,
    watchSelectTimer,
    watchSelectWord,
    writeWord,
    englishCentral,
    answerSelect,
    // Games
    imagePairingGame,
    interactiveVideoGame,
    speakWordGame,
    trueOrFalseGame,
    memoryGame,
    multipleChoiceGame,
    // Perfil
    perfilPage,
    //Books
    books,
    // Loader
    Loader,
    // Pages
    words,
    // Modal
    modal,
    modalSubTopic,
    modalUnit,
    // Online class
    [ChatBox.name]: ChatBox,
    [StudentVideoChat.name]: StudentVideoChat,
    inicialClass,
    modalPdf
  },
  methods: {
    sendMessage () {

    },
    setMuted ({ student_id, muted }) {
      const index = this.students.findIndex(s => s._id == student_id)

      this.$set(this.students[index], 'muted', muted)
    }
  },
  async mounted () {
    this.$store.commit('setTestMode', true)

    // Calling modal
    // try {
    //   const stream = await navigator.mediaDevices.getUserMedia({
    //     video: { facingMode: "user" },
    //     audio: true
    //   })
    //
    //   this.$refs['teacher_video'].srcObject = stream
    //
    //   setTimeout(() => {
    //     for (const student of this.students.filter(s => s.active && s.has_media)) {
    //       const video = this.$refs[`student_video_${student._id}`][0]
    //
    //       video.setStream(stream)
    //     }
    //   }, 2000)
    //
    //   const chatMessages = this.$refs['chat-messages']
    // } catch (error) {
    //   console.log(error)
    // }
  },
  beforeDestroy () {
    this.$store.commit('setTestMode', false)
    this.$store.commit('setShowLoader', false)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/test/index.vue